import styled from 'styled-components';

import { useScopedTranslate } from '@locale/translate';
import { lineClamp } from '@styles/layout-helpers';

import { JourneyAction } from 'api/types';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard, NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { getDescriptionText, useDescription } from './helpers';

type ActionType = 'wait_for_attribute_change';

export const getDescription = (action: JourneyAction<ActionType>): string => {
  return getDescriptionText({ values: action.values, styled: false, translations: nodeLocale });
};

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  const values = node.data?.values;
  const { descriptionText } = useDescription(values, nodeLocale);
  const description = node.data?.description?.trim();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        label={t('title')}
        descriptionText={<ConditionContainer>{description || descriptionText}</ConditionContainer>}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Wait for field change',
    configureAction: 'Configure action',
    continueWhen: 'Continue when\n',
    continueWhenNoStyle: 'Continue when\n{field} {comparator} {value}',
    conditionDescription: '{field} {comparator} {value}',
    changesValue: 'changes',
  },
};

const ConditionContainer = styled.div({
  ...lineClamp('-webkit-inline-box', 1, true),
});
